import { ContainerYardOperationViewStore } from '@planning/pages/VesselVisit/Components'
import { OrderListMenuOptions } from '@planning/pages/VesselVisit/Components/molecules/OrderListMenuOptions'
import { TomTable, useDefaultMRTOptions, useTomTable } from '@tom-ui/ui'
import { useTablePreferencesConfig } from '@tom-ui/utils'
import { MRT_TableInstance } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import { TomTableToolbarAlertBanner } from 'modules/ui/src/theme/components/table/organisms/TomTableToolbarAlertBanner'
import { useRailVisitTableActions } from '../../tableConfigs/useRailVisitTableActions'
import {
  RailVisitTableOrderItemDto,
  useRailVisitTableOrderItemColumns,
} from '../../tableConfigs/useRailVisitTableOrderItemColumns'
import { RailVisitTableViewStore } from './RailVisitTableViewStore'

interface Props {
  tableStore: RailVisitTableViewStore
  containerYardOperationViewStore: ContainerYardOperationViewStore
  renderTableCustomActions: ({
    table,
  }: {
    table: MRT_TableInstance<RailVisitTableOrderItemDto>
  }) => React.ReactNode
}

export const RailVisitTableOrderItem = observer(
  ({ renderTableCustomActions, tableStore, containerYardOperationViewStore }: Props) => {
    const columns = useRailVisitTableOrderItemColumns(tableStore.direction)
    const defaultOptions = useDefaultMRTOptions<RailVisitTableOrderItemDto>()
    const getTableActions = useRailVisitTableActions()

    const { savedPreferences, onPreferencesChange } = useTablePreferencesConfig(
      'planning/rail-visit-orders',
    )

    const table = useTomTable<RailVisitTableOrderItemDto>(
      {
        data: tableStore.tableData,
        columns: columns,
        getRowId: row => row.id.toString(),
        enableTopToolbar: true,
        enableRowSelection: row => !!row.original.originalOrder?.data.containerNumber?.length,
        enableExpanding: false,

        initialState: {
          ...defaultOptions.initialState,
          sorting: [{ id: 'railTrack', desc: false }],
          columnPinning: {
            left: [
              'mrt-row-actions',
              'mrt-row-select',
              'containerNo',
              'railTrack',
              'sequence',
              'railcarNo',
            ],
          },
          pagination: {
            pageIndex: 0,
            pageSize: 50,
          },
        },
        muiTableContainerProps: {
          sx: {
            maxHeight: 'calc(100vh - 280px)',
            minHeight: 'calc(100vh - 280px)',
          },
        },

        renderTopToolbarCustomActions: renderTableCustomActions,

        renderRowActions: ({ row }) => {
          if (!row.original.originalOrder) return null

          const order = row.original.originalOrder
          const journey = order?.containerJourney

          return OrderListMenuOptions({ order, journey, containerYardOperationViewStore })
        },

        renderToolbarAlertBannerContent: ({ table }) => {
          const selectedRows = table.getSelectedRowModel().rows
          const dynamicActions = getTableActions(selectedRows)

          if (!dynamicActions.length) {
            return null
          }

          return <TomTableToolbarAlertBanner table={table} tableActions={dynamicActions} />
        },
      },
      undefined,
      undefined,
      { columns, savedPreferences, onPreferencesChange },
    )

    return <TomTable table={table} />
  },
)
